import AccountReservations from './AccountReservations';

export default AccountReservations;
